import AppModal from '@/components/AppModal/AppModal';
import { handleSaveOrderFilterTableSettings, orderFilterSettingSelector } from '@/redux/slice/order.slice';
import { DatePicker } from '@shopify/polaris';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface Props {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const CalendarModal = ({ open, onSubmit, onCancel }: Props) => {
  const today = useMemo(() => new Date(), []);
  const [{ month, year }, setDate] = useState({ month: today.getMonth(), year: today.getFullYear() });
  const { customDate } = useSelector(orderFilterSettingSelector);
  const dispatch = useDispatch();

  const selectedDates = useMemo(
    () => ({
      start: customDate?.start ? new Date(customDate.start) : today,
      end: customDate?.end ? new Date(customDate.end) : today,
    }),
    [customDate?.end, customDate?.start, today],
  );

  const handleDateChange = useCallback(
    (value: { start: Date; end: Date }) => {
      dispatch(
        handleSaveOrderFilterTableSettings({
          customDate: {
            start: value.start.toISOString(),
            end: value.end.toISOString(),
          },
        }),
      );
    },
    [dispatch],
  );

  const handleMonthChange = useCallback((month: number, year: number) => setDate({ month, year }), []);
  return (
    <AppModal
      title="Custom date range"
      open={open}
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitText="Confirm"
      cancelText="Cancel"
      disabledPrimary={false}
    >
      <DatePicker
        month={month}
        year={year}
        onChange={handleDateChange}
        onMonthChange={handleMonthChange}
        selected={selectedDates}
        allowRange
      />
    </AppModal>
  );
};
